export default __webpack_public_path__ + "static/poppins-v20-latin-ext-700-26810ac68c87bfe00ba0841b18cad2ee.woff2";